import type { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';
import type { Entity } from '@backstage/catalog-model';
import type { Api } from './ApiRef';
import { pluginConfig } from '../config';

export class Client implements Api {
  discoveryApi: DiscoveryApi;
  identityApi: IdentityApi;
  constructor({
    discoveryApi,
    identityApi,
  }: {
    discoveryApi: DiscoveryApi;
    identityApi: IdentityApi;
  }) {
    this.discoveryApi = discoveryApi;
    this.identityApi = identityApi;
  }

  private async callApi<T>(
    path: string,
    query: { [key in string]: any },
    options?: { method?: string },
  ): Promise<T> {
    const apiUrl = await this.discoveryApi.getBaseUrl(
      `${pluginConfig.pluginId}`,
    );
    const { token } = await this.identityApi.getCredentials();

    const response = await fetch(
      `${apiUrl}/${path}?${new URLSearchParams(query).toString()}`,
      {
        method: options?.method ?? 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error(
        `Request failed for ${path}, ${response.status} ${response.statusText}`,
      );
    }

    return (await response.json()) as T;
  }

  async getComponents(limit?: number, kind?: string): Promise<Entity[]> {
    const options: {
      limit?: number;
      kind?: string;
    } = {};

    if (limit) {
      options.limit = limit;
    }

    if (kind) {
      options.kind = kind;
    }

    const result = await this.callApi<Entity[]>('components', options);

    return result;
  }
}
